import React from 'react'
import { Stack } from '@mui/material'

const TabPanel = ({ children, value, index, ...other }) => {
  if (value !== index) {
    return null
  }

  return (
    <Stack
      sx={{
        display: 'flex',
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar ': {
          display: 'none'
        }
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {children}
    </Stack>
  )
}

export default TabPanel
